import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type CustomizeIconProps = IconProps;

export const CustomizeIcon: FC<CustomizeIconProps> = ({
  iconColor = '#344054',
  className,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 0.75V17.25M11.75 0.75V17.25M5.15 0.75H12.85C14.3901 0.75 15.1602 0.75 15.7485 1.04973C16.2659 1.31338 16.6866 1.73408 16.9503 2.25153C17.25 2.83978 17.25 3.60986 17.25 5.15V12.85C17.25 14.3901 17.25 15.1602 16.9503 15.7485C16.6866 16.2659 16.2659 16.6866 15.7485 16.9503C15.1602 17.25 14.3901 17.25 12.85 17.25H5.15C3.60986 17.25 2.83978 17.25 2.25153 16.9503C1.73408 16.6866 1.31338 16.2659 1.04973 15.7485C0.75 15.1602 0.75 14.3901 0.75 12.85V5.15C0.75 3.60986 0.75 2.83978 1.04973 2.25153C1.31338 1.73408 1.73408 1.31338 2.25153 1.04973C2.83978 0.75 3.60986 0.75 5.15 0.75Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
  </svg>
);
